import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const RotaPrivada = () => {
  // Verifica se o token de login está guardado.
  // ATENÇÃO: Se no teu login guardaste o token com outro nome (ex: 'token' em vez de 'access_token'), muda o nome aqui!
  const isAuthenticated = localStorage.getItem('token') !== null;

  // Se o gajo não tem token leva um chuto para o Login.
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Se tem token, a porta abre-se e ele entra na página.
  return <Outlet />;
};

export default RotaPrivada;